$(function(){
  /* Cart popup: start */
    function addItemToCart(variant_id, selling_plan, qty) {
      data = {
        "id": variant_id,
        "selling_plan": selling_plan, 
        "quantity": qty
      }

      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
          $('.member_ship_container').hide();
          window.location.href = '/cart';
        }
      });
    }

    $(document).on('click', '.selling_plans, #member_ship_add', function() {
      addItemToCart($(this).attr('variant_id'), $(this).attr('selling_plan'), 1);
    });
  /* Cart popup: end */
  
  /* Cart page: start */
  function getPercentage(price, percentage)
  {
  	var new_price = price * ( 100 - parseFloat(percentage));
    return (new_price / 100).toFixed(2)
  }
  
  $(document).on('click', '.remove-membership', function(){
    $('.cart-subtotal .money.old_money').remove();
    $('.cart-subtotal .money').css('text-decoration', 'auto');
    $('.cart-title-total .money').css('text-decoration', 'auto');
    $('.has-membership').hide();
    $('.no-membership').show();
  });
  /* Cart page: end */
});